<template>
  <div class="taber" :style="bgStyle">
    <div class="item" @click="goUrl('/robot')"></div>
    <div class="item" @click="goUrl('/road')"></div>
    <div class="item" @click="goUrl('/')"></div>
    <div class="item" ></div>
    <div class="item" @click="goUrl('/cloud')"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

// 先定义函数再使用
const findRouteBg = () => {
  return route.matched[0]?.meta.bg || ''
}

// 后初始化ref
const currentRouteBg = ref(findRouteBg())

// 响应式背景样式
const bgStyle = computed(() => {
  return currentRouteBg.value 
    ? { backgroundImage: `url(${currentRouteBg.value})` } 
    : {}
})

// 路由跳转逻辑
const goUrl = (path: string) => {
  router.replace(path)
}

// 监听路由变化
watch(
  () => route.matched,
  () => {
    currentRouteBg.value = findRouteBg()
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss" scoped>
@use "./index.scss";
</style>
